class ShippingProgress {
  constructor() {
    // Get threshold from data attribute, default to 5900 if not found
    const container = document.querySelector('[data-shipping-progress]');
    this.freeShippingThreshold = container ? parseInt(container.dataset.threshold) || 5900 : 5900;
    this.containers = document.querySelectorAll('[data-shipping-progress]');
    this.progressBars = document.querySelectorAll('[data-progress-bar]');
    this.messageContainers = document.querySelectorAll('[data-shipping-message]');
    this.updateTimeout = null;
    
    // Set up MutationObserver for cart drawer
    this.setupCartObserver();
    
    // Listen for cart updates
    document.addEventListener('cart:updated', () => this.scheduleUpdate());
    document.addEventListener('cart:requestComplete', () => this.scheduleUpdate());
    document.addEventListener('cart:drawer:updated', () => this.scheduleUpdate());
    
    // Listen for AJAX cart updates
    document.addEventListener('ajaxProduct:added', () => this.scheduleUpdate());
    document.addEventListener('ajaxProduct:removed', () => this.scheduleUpdate());
    document.addEventListener('ajaxProduct:updated', () => this.scheduleUpdate());
    
    // Listen for quantity changes in both cart locations
    const cartForms = document.querySelectorAll('.cart__drawer-form, #CartPageForm');
    cartForms.forEach(form => {
      if (form) {
        form.addEventListener('change', (event) => {
          if (event.target.matches('input[type="number"]')) {
            this.waitForCartUpdate();
          }
        });
      }
    });

    // Listen for cart API updates
    document.addEventListener('cart:api:updated', () => this.scheduleUpdate());
    
    // Initial update
    this.scheduleUpdate();
  }

  setupCartObserver() {
    const cartForms = document.querySelectorAll('.cart__drawer-form, #CartPageForm');
    cartForms.forEach(form => {
      if (!form) return;

      const subtotalElement = form.querySelector('[data-subtotal]');
      if (!subtotalElement) return;

      // Create observer to watch for changes in the subtotal
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'characterData' || mutation.type === 'childList') {
            // Clear any existing timeout
            if (this.updateTimeout) {
              clearTimeout(this.updateTimeout);
            }
            // Update immediately when subtotal changes
            this.updateShippingProgress();
          }
        });
      });

      // Start observing the subtotal element
      observer.observe(subtotalElement, {
        characterData: true,
        childList: true,
        subtree: true
      });
    });
  }

  waitForCartUpdate() {
    // Clear any existing timeout
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    // Check for cart update completion
    const checkCartUpdate = () => {
      const cartForms = document.querySelectorAll('.cart__drawer-form, #CartPageForm');
      let allUpdated = true;

      cartForms.forEach(form => {
        if (!form) return;

        const subtotalElement = form.querySelector('[data-subtotal]');
        if (!subtotalElement) return;

        // If the cart is still updating, the subtotal might be empty or loading
        if (!subtotalElement.textContent.trim()) {
          allUpdated = false;
        }
      });

      if (!allUpdated) {
        this.updateTimeout = setTimeout(checkCartUpdate, 50);
        return;
      }

      // Cart has updated, now update the shipping progress
      this.updateShippingProgress();
    };

    // Start checking for cart update
    checkCartUpdate();
  }

  scheduleUpdate() {
    // Clear any existing timeout
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }
    
    // Schedule new update
    this.updateTimeout = setTimeout(() => {
      this.updateShippingProgress();
    }, 50);
  }

  updateShippingProgress() {
    if (!this.containers.length) return;

    // Always fetch the latest cart data from the API
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price;
        this.updateProgressAndMessage(cartTotal);
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
        // Fallback to DOM-based calculation if API fails
        this.updateFromDOM();
      });
  }

  updateFromDOM() {
    const cartForms = document.querySelectorAll('.cart__drawer-form, #CartPageForm');
    let cartTotal = 0;

    cartForms.forEach(form => {
      if (!form) return;

      const subtotalElement = form.querySelector('[data-subtotal]');
      if (!subtotalElement) return;

      const priceText = subtotalElement.textContent.trim();
      if (!priceText) return;

      const extractedTotal = this.extractPriceFromText(priceText);
      if (extractedTotal > cartTotal) {
        cartTotal = extractedTotal;
      }
    });

    if (cartTotal > 0) {
      this.updateProgressAndMessage(cartTotal);
    }
  }

  updateProgressAndMessage(cartTotal) {
    // Update progress bar width for all instances
    const progressPercentage = cartTotal >= this.freeShippingThreshold 
      ? 100 
      : (cartTotal / this.freeShippingThreshold) * 100;
    
    requestAnimationFrame(() => {
      this.progressBars.forEach(bar => {
        if (bar) {
          bar.style.width = `${progressPercentage}%`;
        }
      });

      // Update message for all instances
      const message = cartTotal >= this.freeShippingThreshold
        ? '<p class="free-shipping-message">You have qualified for <strong>free shipping</strong>!</p>'
        : `<p class="shipping-progress-message">You are <strong>${this.formatMoney(this.freeShippingThreshold - cartTotal)}</strong> away from <strong>free shipping</strong></p>`;

      this.messageContainers.forEach(container => {
        if (container) {
          container.innerHTML = message;
        }
      });
    });
  }

  extractPriceFromText(priceText) {
    // Remove currency symbol and any non-numeric characters except decimal point
    const numericString = priceText.replace(/[^0-9.]/g, '');
    // Convert to cents
    return Math.round(parseFloat(numericString) * 100);
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }
}

// Initialize shipping progress
document.addEventListener('DOMContentLoaded', () => {
  new ShippingProgress();
}); 